import { useLayoutEffect } from 'react';
import useWhiteLabelProject from 'Hook/useEntkhabino';
import reactManifest from 'react-manifest';
import { manifestConfigs } from 'utils/manifestConfigs';

const useManifest = () => {
	const {
		isEntekhab,
		isHamtaland,
		isRayansaipa,
		isDemo,
		isTisa,
		isSaana,
		isArbaeen,
	} = useWhiteLabelProject();

	useLayoutEffect(() => {
		const getActiveManifest = () => {
			if (isEntekhab) return manifestConfigs.entekhab;
			if (isHamtaland) return manifestConfigs.hamtaland;
			if (isRayansaipa) return manifestConfigs.rayansaipa;
			if (isDemo) return manifestConfigs.demo;
			if (isTisa) return manifestConfigs.tisa;
			if (isSaana) return manifestConfigs.saana;
			if (isArbaeen) return manifestConfigs.arbaeen;
			return manifestConfigs.keepa;
		};

		reactManifest.update(getActiveManifest(), '#manifest-placeholder');
	});

	return null;
};

export default useManifest;
